import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getProfileQuotationList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/profile-quotation/`, {
    headers: authHeader(),
    params: {
      deleted:0,
      page: page,
      pagesize: pagesize,
      search: search, // You might want to include search here, if applicable
      ordering: ordering
    },
  });
};

const getArchiveProfileQuotationList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL +'/api/'+ API_VERSION + '/profile-quotation/?deleted=1', {headers: authHeader(), params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering
    }});
};

const getProfileQuotationById = (id) => {
    return axios.get(API_URL +'/api/'+ API_VERSION + '/profile-quotation/', {headers: authHeader(), params: {
        id: id
    }});
};
const editProfileQuotation = (id, categoryData) => {
    return axios.patch(
      `${API_URL}/api/${API_VERSION}/profile-quotation/${id}/`,
      categoryData, 
      { headers: authHeader() }
    );
  };
const createProfileQuotation = categoryData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/profile-quotation/`,
    categoryData,
    {
      headers: authHeader(),
    },
  );
};
const deleteProfileQuotation = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/profile-quotation/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveProfileQuotation = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/profile-quotation/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const profileQuotationService = {
    getProfileQuotationList,
    getArchiveProfileQuotationList,
    getProfileQuotationById,
    createProfileQuotation,
    editProfileQuotation,
    deleteProfileQuotation,
    unArchiveProfileQuotation
};

export default profileQuotationService;
